import { render } from "./HorizontalLink.vue?vue&type=template&id=3d37c9a0&scoped=true"
import script from "./HorizontalLink.vue?vue&type=script&lang=js"
export * from "./HorizontalLink.vue?vue&type=script&lang=js"

import "./HorizontalLink.vue?vue&type=style&index=0&id=3d37c9a0&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d37c9a0"]])

export default __exports__